import {
  faBuilding,
  faBullseyeArrow,
  faUser,
} from "@fortawesome/pro-regular-svg-icons";

import {
  CommandbarFilterTabType,
  type CommandbarFilterTab,
} from "../types/common";

export const COMMANDBAR_FILTER_TABS: CommandbarFilterTab[] = [
  {
    label: CommandbarFilterTabType.ALL,
  },
  {
    label: CommandbarFilterTabType.COMMAND,
  },
  {
    label: CommandbarFilterTabType.PAGE,
  },
  {
    label: CommandbarFilterTabType.OPPORTUNITY,
    icon: faBullseyeArrow,
  },
  {
    label: CommandbarFilterTabType.ACCOUNT,
    icon: faBuilding,
  },
  {
    label: CommandbarFilterTabType.CONTACT,
    icon: faUser,
  },
];

export const COMMANDBAR_WIDTH = 700;
export const NEXT_MEETING_COMMAND_ID = "next-meeting";
